import { render, staticRenderFns } from "./DictionaryForm.vue?vue&type=template&id=3530c361&scoped=true&"
import script from "./DictionaryForm.vue?vue&type=script&lang=js&"
export * from "./DictionaryForm.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryForm.vue?vue&type=style&index=0&id=3530c361&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3530c361",
  null
  
)

export default component.exports